import { render } from "./Renewal.vue?vue&type=template&id=5b28caf7"
import script from "./Renewal.vue?vue&type=script&lang=js"
export * from "./Renewal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__